import { createInsertSchema, createSelectSchema } from "drizzle-zod";
import { z } from "zod";
import { stepTypes } from "../drizzle/stepTypes.js";
export const stepTypeSchema = createSelectSchema(stepTypes, {
    key: (schema) => schema.meta({
        description: "Unique key identifying the step type (also the primary key)",
        example: "cost_estimate_check",
    }),
    // Use z.coerce.date() for date fields because JSON serialization converts Date objects to ISO strings
    createdAt: () => z.coerce.date().meta({
        description: "Step type creation timestamp",
        example: "2024-01-15T10:30:00.000Z",
    }),
    updatedAt: () => z.coerce.date().meta({
        description: "Step type last update timestamp",
        example: "2024-01-15T10:30:00.000Z",
    }),
    title: (schema) => schema.meta({
        description: "Step type title",
        example: "Upload Invoice PDF",
    }),
    description: (schema) => schema.meta({
        description: "Step type description",
        example: "Upload the invoice PDF document for processing",
    }),
    responsibleAgent: (schema) => schema.meta({
        description: "Agent responsible for this step type",
        example: "user",
    }),
}).describe("Step type object");
// Base schema using callbacks - stays in sync with Drizzle column types
const baseCreateStepTypeSchema = createInsertSchema(stepTypes, {
    key: (schema) => schema.meta({
        description: "Unique key identifying the step type (also the primary key)",
        example: "cost_estimate_check",
    }),
    title: (schema) => schema.min(1, "Bitte gib einen Titel an").meta({
        description: "Step type title",
        example: "Upload Invoice PDF",
    }),
    description: (schema) => schema
        .meta({
        description: "Step type description",
        example: "Upload the invoice PDF document for processing",
    })
        .nullable(),
    responsibleAgent: (schema) => schema.meta({
        description: "Agent responsible for this step type",
        example: "user",
    }),
});
// Fix drizzle-zod bug: callbacks for nullable fields lose .optional() wrapper
// We extend the base schema to add .optional() to nullable fields
export const createStepTypeSchema = baseCreateStepTypeSchema
    .extend({
    description: baseCreateStepTypeSchema.shape.description.optional(),
})
    .describe("Create step type request body");
